import ConversationalAiCard from "./features"
import CTASection from "../../landing/landing_home/empower"
import Footer from "../../Footer/footer"
import Navigation from "../../navigation/header"
import Hero from "../../landing/utils/hero";

const Students = () => {

  return (
    <>
      <Navigation />
      <Hero
        title="AI-Powered Student Engagement for Every Campus"
        subtitle="Boost enrollment, retention, and outcomes with Campus Insights"
      />
      <ConversationalAiCard />
      <CTASection />
      <Footer />
    </>
  );
};


export default Students;
